import { render } from "./OurPlans.vue?vue&type=template&id=61dff7eb&scoped=true"
import script from "./OurPlans.vue?vue&type=script&lang=js"
export * from "./OurPlans.vue?vue&type=script&lang=js"

import "./OurPlans.vue?vue&type=style&index=0&id=61dff7eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61dff7eb"]])

export default __exports__